export class Cmc {
  constructor({ cmcID = 0, orderID = 0, product = null, licenses = [] } = {}) {
    this.cmcID = cmcID;
    this.orderID = orderID;
    this.product = product;
    this.licenses = licenses;
  }
}
export function createCmc(data) {
  return Object.freeze(new Cmc(data));
}
